var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsurance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.57 140.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9ca5ad;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#505050;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.57,68.77h0a21.27,21.27,0,0,1-4-.78,32.38,32.38,0,0,0-15.89.78c-3.17,1.06-3.43.8-3.69-2.39a107.33,107.33,0,0,0-6.61-25.9,68.42,68.42,0,0,0-15.61-23A3.62,3.62,0,0,1,81,15.35c.78-.8,1.32-.26,2.1-.26,22.48,5,41.8,25.39,45.22,48.13,0,.52.29.8.29,1.32v4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,68.77H0A29.28,29.28,0,0,0,4.23,68a32.28,32.28,0,0,1,15.87.78c3.19,1.06,3.19.8,3.71-2.39a87.4,87.4,0,0,1,6.61-25.9A61.63,61.63,0,0,1,46,17.45c.52-.52,1.58-1,1.58-2.1-.52-.8-1.32-.26-2.1-.26C23,20.09,4,40.48.52,63.22c-.24.52-.24.8-.52,1.32v4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.06,120.34h0L41,119.28c0,5.29,1.06,8.74,2.93,10.58a8.85,8.85,0,0,0,7.13,2.93,9.71,9.71,0,0,0,5.55-1.61A7.65,7.65,0,0,0,60.05,127c.53-1.58.79-4.49.79-8.46V72.22h9V118c0,5.83-.54,10.06-1.86,13.22a17.25,17.25,0,0,1-6.61,7.16,21.32,21.32,0,0,1-10.32,2.38c-6.09,0-10.58-1.86-13.49-5.29-3.18-3.18-4.77-8.21-4.51-15.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.67,0h0c2.64,2.64,0,8.74,1.58,11.9C69,13.48,71.7,13,73.54,13.77c5.55,2.9,9.8,7.39,13.23,12.42C94.7,37,98.41,49.47,100.53,62.42a35.1,35.1,0,0,1,1,5.57c0,1.32,0,2.1-1.84,1.32-9.54-3.45-19.57-5-29.64-6.09-8.19-.8-16.13.52-24.32,2.12a92.94,92.94,0,0,0-14.29,4c-1.84.52-2.38-.28-2.12-1.86a94.37,94.37,0,0,1,1.86-11.91C33.87,44.44,37.57,33.6,45,24.61c3.45-4.77,7.41-9.26,13.22-11.13,4.77-1.84,4.77-1.58,5-6.87,0-2.38-1-4.77,1.07-6.61Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.24e1dc1794c3ef7cded4fe0c8166d2bf.svg";
export { ForwardRef as ReactComponent };